/**
 * Tip Calculator - UI interactivity only.
 * Tip button selection, split +/- controls, and hidden field sync.
 * All calculations happen server-side in TipCalculatorService.
 */
(function () {
    'use strict';

    function init() {
        var tipField = document.getElementById('tip-percentage-field');
        var customTipInput = document.getElementById('custom-tip');
        var splitInput = document.querySelector('[name="Input.SplitCount"]');
        var splitMinusBtn = document.getElementById('split-minus');
        var splitPlusBtn = document.getElementById('split-plus');

        if (!tipField) return;

        // Tip button handlers: update hidden field + active state
        document.querySelectorAll('.tip-btn').forEach(function (btn) {
            btn.addEventListener('click', function () {
                var pct = btn.getAttribute('data-tip');
                tipField.value = pct;

                document.querySelectorAll('.tip-btn').forEach(function (b) {
                    b.classList.remove('active');
                });
                btn.classList.add('active');

                if (customTipInput) {
                    customTipInput.value = '';
                }
            });
        });

        // Custom tip input: update hidden field + clear active buttons
        if (customTipInput) {
            customTipInput.addEventListener('input', function () {
                var val = parseInt(customTipInput.value);
                if (!isNaN(val) && val >= 0 && val <= 100) {
                    tipField.value = val.toString();
                    document.querySelectorAll('.tip-btn').forEach(function (b) {
                        b.classList.remove('active');
                    });
                }
            });
        }

        // Split +/- buttons
        if (splitMinusBtn && splitInput) {
            splitMinusBtn.addEventListener('click', function () {
                var current = parseInt(splitInput.value) || 1;
                if (current > 1) {
                    splitInput.value = (current - 1).toString();
                }
            });
        }

        if (splitPlusBtn && splitInput) {
            splitPlusBtn.addEventListener('click', function () {
                var current = parseInt(splitInput.value) || 1;
                if (current < 50) {
                    splitInput.value = (current + 1).toString();
                }
            });
        }

        // Scroll to results on page load if results exist
        var results = document.getElementById('tc-results');
        if (results) {
            results.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();